import type { CSSProperties } from "react";

// The mark and wordmark from public/logo.svg (drawn by video/logo.js), inline rather than an <img>
// so each part can be animated on its own. Same geometry as the file: a 120-unit tile, then the
// outlined DM Sans wordmark to its right.
const LINE = "M19 96L43 70L55 82L68.19 64.27";
const STAR = "87.00,18.00 92.29,31.72 106.97,32.51 95.56,41.78 99.34,55.99 87.00,48.00 74.66,55.99 78.44,41.78 67.03,32.51 81.71,31.72";
const LETTERS = [
  "M45 992V292H311.7Q396.5 292 452.3 320.7Q508.1 349.4 535.5 398.5Q562.9 447.6 562.9 510.1Q562.9 567.8 536.6 617Q510.3 666.2 454.6 696.6Q398.9 727 311.7 727H185V992ZM185 614.2H302.6Q365 614.2 392.6 585.9Q420.3 557.6 420.3 510.1Q420.3 461 392.6 433.4Q365 405.8 302.6 405.8H185Z",
  "M843.4 1004Q771.4 1004 713.5 970.7Q655.6 937.4 621.8 878.8Q588 820.2 588 744Q588 667.6 622 608.8Q655.9 549.9 714 517Q772 484 844 484Q916 484 973.9 517Q1031.9 549.9 1065.7 608.8Q1099.4 667.6 1099.4 744Q1099.4 820.4 1065.5 878.9Q1031.5 937.4 973.5 970.7Q915.5 1004 843.4 1004ZM843.2 885.6Q874.8 885.6 900.2 869.9Q925.6 854.2 941.2 822.6Q956.8 791.1 956.8 744.1Q956.8 696.7 941.4 665.1Q926 633.5 900.5 618Q875.1 602.4 844.5 602.4Q813.7 602.4 787.8 618Q761.8 633.5 746.2 665.1Q730.6 696.7 730.6 744.1Q730.6 791.1 746.2 822.6Q761.8 854.2 787.4 869.9Q813 885.6 843.2 885.6Z",
  "M1159.7 992V496H1299.7V992ZM1230 436.9Q1192.2 436.9 1168.1 414.5Q1144 392.1 1144 358.6Q1144 324.9 1168 302.5Q1192 280 1230 280Q1268.2 280 1292.3 302.5Q1316.4 324.9 1316.4 358.8Q1316.4 392 1292.3 414.4Q1268.2 436.9 1230 436.9Z",
  "M1376 992V496H1495.1L1506.9 577.2H1510.9Q1535 533 1576 508.5Q1617.1 484 1679.3 484Q1741.4 484 1784.4 510.7Q1827.4 537.4 1850 588.8Q1872.5 640.2 1872.5 714.9V992H1733.1V727.7Q1733.1 667.5 1708.8 634.6Q1684.5 601.7 1630.9 601.7Q1597.5 601.7 1571.4 617.9Q1545.3 634 1530.7 663.9Q1516 693.7 1516 736.3V992Z",
  "M2155.5 992Q2102.2 992 2061.8 975.1Q2021.4 958.2 1999 919.2Q1976.7 880.3 1976.7 813V608.8H1892V496H1976.7L1991.9 359.6H2116.9V496H2247.3V608.8H2116.7V814.3Q2116.7 848.9 2131.2 862.2Q2145.7 875.5 2180.8 875.5H2245.1V992Z",
  "M2258 992V881.7L2507.1 609.9H2261.1V496H2665.3V606.3L2413 878.1H2670.3V992Z",
];

/**
 * The Pointz logo. With `animate` it plays its reveal once as it mounts (the line draws, the
 * star pops, the letters rise one after another), in CSS only (styles.css); otherwise, and always
 * with reduced motion, it is simply drawn. Its height comes from `className`.
 */
export function PointzLogo({ animate = false, className = "" }: { animate?: boolean; className?: string }) {
  return (
    <svg
      className={`pz-logo${animate ? " pz-logo--animate" : ""} ${className}`.trim()}
      viewBox="0 0 385 120"
      role="img"
      aria-label="Pointz"
    >
      <rect className="pz-logo__tile" width="120" height="120" rx="28" />
      <path className="pz-logo__line" d={LINE} pathLength={1} />
      <g className="pz-logo__star">
        <polygon points={STAR} />
      </g>
      <g className="pz-logo__word" transform="translate(144 28) scale(0.09143) translate(-45 -292)">
        {LETTERS.map((d, i) => (
          <path key={i} className="pz-logo__letter" d={d} style={{ "--i": i } as CSSProperties} />
        ))}
      </g>
    </svg>
  );
}
